module.exports = __webpack_public_path__ + "static/media/type-4.59b04aa5.svg";